import ArrowIcon from '~/assets/icons/Arrow';

export default function NotificationTooltip({
  className,
  isRevealed
}: {
  className?: string;
  isRevealed: boolean;
}) {
  return (
    <div
      className={`flex h-8 items-center justify-between bg-purple-hola-super-light p-2 opacity-0 motion-reduce:animate-none motion-reduce:opacity-100 md:py-1.5 ${isRevealed ? 'animate-slide-delay' : ''} ${className}`}
    >
      <div className="text-xs leading-3 text-purple-hola">
        Tap the bell to get a release alert
      </div>
      <div className="rotate-270">
        <ArrowIcon fill="#8907e7" className="motion-safe:animate-pulse" />
      </div>
    </div>
  );
}
